import { FC } from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import WYSIWYG from '../WYSIWYG'
interface Accordion {
  accordionTitle?: string
  accordionText?: any
}

interface AccordionProps {
  accordion: Accordion[]
}

const FAQAccordion: FC<AccordionProps> = ({ accordion }) => {
  return (
    <>
      <Accordion allowMultipleExpanded allowZeroExpanded>
        {accordion?.map((item: Accordion, index: number) => {
          if (!item.accordionTitle || !item.accordionText) return null
          return (
            <AccordionItem key={index} className="border-b border-ui-grey-25">
              {item?.accordionTitle && (
                <AccordionItemHeading>
                  <AccordionItemButton className="accordion__button">
                    <div className=" pr-10 font-roboto text-body1 font-normal text-brand-dark-grey">
                      {item.accordionTitle}
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
              )}
              {item?.accordionText && (
                <AccordionItemPanel>
                  <div className="body-1 text-brand-dark-grey">
                    <WYSIWYG content={item?.accordionText} />
                  </div>
                </AccordionItemPanel>
              )}
            </AccordionItem>
          )
        })}
      </Accordion>
      <style jsx global>
        {`
          .accordion .accordion__button {
            position: relative;
            display: flex;
            align-items: center;
            width: 100%;
            border-top: 0;
            border-right: 0;
            border-left: 0;
            text-align: left;
            padding: 24px 0 24px 0;
            transition: color 0.2s linear;
            cursor: pointer;
            color: rgb(0, 0, 0);
          }
          .accordion .accordion__button:focus {
            outline: none;
          }
          .accordion .accordion__button:after,
          .accordion .accordion__button:before {
            content: '';
            position: absolute;
            right: 0px;
            top: 50%;
            width: 16px;
            height: 1px;
            margin-top: -2px;
            background-color: #646464;
          }
          .accordion .accordion__button:before {
            -webkit-transform: rotate(-90deg);
            transform: rotate(-90deg);
            transition: -webkit-transform 0.35s
              cubic-bezier(0.65, 0.05, 0.36, 1);
            transition: transform 0.35s cubic-bezier(0.65, 0.05, 0.36, 1),
              -webkit-transform 0.35s cubic-bezier(0.65, 0.05, 0.36, 1);
          }
          .accordion .accordion__button[aria-expanded='true']:before {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
          }
          .accordion .accordion__panel {
            padding: 0px 0 24px 0;
          }
        `}
      </style>
    </>
  )
}

export default FAQAccordion
